// 财务信息管理
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">财务信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-top:-15px;margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="cert_no" label="证书号：" label-width="100px">
                                <el-input v-model="query.cert_no" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="account_date" label="记账日期：" label-width="100px">
                                <el-date-picker v-model="query.account_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="clients" label="客户名称：" label-width="100px">
                                <el-input v-model="query.clients" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="arrived_date" label="到账日期：" label-width="100px">
                                <el-date-picker v-model="query.arrived_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-right:200px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAll" size="small">导出全部</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-table :data="financialInfoList" border @selection-change="selectionLineChangeHandle"
                            ref="refTable"
                            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" width="120" prop="cert_no" label="证书号"></el-table-column>
                            <el-table-column align="center" width="100" prop="clients" label="客户名称"></el-table-column>
                            <el-table-column align="center" width="100" prop="diamond_status" label="货品状态"></el-table-column>
                            <el-table-column align="center" width="100" prop="account_date" label="记账日期"></el-table-column>
                            <el-table-column align="center" width="100" prop="arrived_date" label="到账日期"></el-table-column>
                            <el-table-column align="center" width="100" prop="cost_rap" label="成本rap($)"></el-table-column>
                            <el-table-column align="center" width="120" prop="cost_dis" label="成本折扣(%)"></el-table-column>
                            <el-table-column align="center" width="100" prop="cost" label="货品成本($)"></el-table-column>
                            <el-table-column align="center" width="100" prop="point" label="综合费点"></el-table-column>
                            <el-table-column align="center" width="100" prop="usd_cost" label="美金成本($)"></el-table-column>
                            <el-table-column align="center" width="120" prop="rmb_cost" label="人民币成本(￥)"></el-table-column>
                            <el-table-column align="center" width="100" prop="sale_usd" label="销售美金($)"></el-table-column>
                            <el-table-column align="center" width="100" prop="sale_rate" label="销售汇率"></el-table-column>
                            <el-table-column align="center" width="100" prop="back" label="退点(%)"></el-table-column>
                            <el-table-column align="center" width="100" prop="sale_price" label="售价(￥)"></el-table-column>
                            <el-table-column align="center" width="100" prop="paid" label="实收(￥)"></el-table-column>
                            <el-table-column align="center" width="100" prop="income" label="利润(￥)"></el-table-column>
                            <el-table-column align="center" width="120" prop="profit_rate" label="应收利润率(%)"></el-table-column>
                            <el-table-column align="center" width="150" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" width="120" prop="create_user" label="业务员"></el-table-column>
                            <el-table-column align="center" width="100" prop="data_date" label="数据日期"></el-table-column>
                            <el-table-column align="center" width="150" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectSavaList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    export default {
        data() {
            return {
                isAble: true,
                placeList: [{'value':'全部'},{'value':'HK'},{'value':'CHINA'},{'value':'SZ'}
                            ,{'value':'INDIA'},{'value':'LAB'},{'value':'SH'},{'value':'H-K'}],
                isq: '',
                inv_status: '',
                addDataForm: {},
                addDataForm3: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                financialInfoList: [],
                financialInfoAllList: [],
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/order/deleteOrdersInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 修改订单数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/order/savaOrdersInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            stock_id: _this.addDataForm.stock_id,
                            cert_no: _this.addDataForm.cert_no,
                            id: _this.addDataForm.id,

                            rate: _this.addDataForm.rate,
                            back: _this.addDataForm.back,
                            status: _this.addDataForm.status,
                            received_type: _this.addDataForm.received_type,
                            price: _this.addDataForm.price,
                            received: _this.addDataForm.received,
                            remark: _this.addDataForm.remark
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '财务信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 导出全部数据
            exportAll() {
                this.selectAllList();
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['证书号','客户名称','货品状态', '记账日期', '到账日期'
                            , '成本rap', '成本折扣', '货品成本', '综合费点', '美金成本', '人民币成本'
                            , '销售美金', '销售汇率', '售价', '实收', '利润', '应收利润率'
                            , '备注', '业务员', '数据日期']
                    const filterVal = ['cert_no','clients','diamond_status', 'account_date', 'arrived_date'
                            ,'cost_rap', 'cost_dis', 'cost', 'point', 'usd_cost', 'rmb_cost'
                            , 'sale_usd', 'sale_rate', 'sale_price', 'paid', 'income', 'profit_rate'
                            , 'remark' , 'create_user', 'data_date' ]
                    const list = this.financialInfoAllList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部财务信息')
                })
            },
            // 加载信息分页列表
            selectList() {
                let _this = this;
                util.publicget('/financial/queryFinancialInfoListPageModel', {
                    // cert_no: '203652.36',
                    cert_no: _this.query.cert_no,
                    equalsClients: _this.query.clients,
                    greaterEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[0],
                    lessEqualsAccount_date: _this.query.account_date == null ? '' : _this.query.account_date[1],
                    greaterEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[0],
                    lessEqualsArrived_date: _this.query.arrived_date == null ? '' : _this.query.arrived_date[1],
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.financialInfoList = res.obj;  
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询订单单条记录
            selectSavaList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载查询订单全部记录
            selectAllList(rows) {
                let _this = this;
                util.publicget('/financial/queryFinancialList', {}, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        _this.financialInfoAllList = res.obj;
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            }
        },
        mounted() {
            this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/financial/financialInfoList.vue